import { rootReducer } from '@/store/lazyLoadedSlices';
import { createSlice } from '@reduxjs/toolkit';


/**
 * The initial state of the notification slice.
 */
const initialState = {
	state: false,
	options: {
		variant: 'info', // 'success', 'error', 'warning', 'info'
		anchorOrigin: {
			vertical: 'top',
			horizontal: 'center'
		},
		autoHideDuration: 3000,
		message: '',
		preventDuplicate: true
	}
};

/**
 * The Notification slice.
 */
export const notificationSlice = createSlice({
	name: 'notification',
	initialState,
	reducers: {
		showMessage(state, action) {
			state.state = true;
			state.options = {
				...initialState.options,
				...action.payload
			};
		},
		hideMessage(state) {
			state.state = false;
		},
		showSuccess(state, action) {
			state.state = true;
			state.options = {
				...initialState.options,
				variant: 'success',
				message: action.payload,
				autoHideDuration: 3000
			};
		},
		showError(state, action) {
			state.state = true;
			state.options = {
				...initialState.options,
				variant: 'error',
				message: action.payload,
				autoHideDuration: 5000
			};
		},
		showWarning(state, action) {
			state.state = true;
			state.options = {
				...initialState.options,
				variant: 'warning',
				message: action.payload,
				autoHideDuration: 4000
			};
		},
		showInfo(state, action) {
			state.state = true;
			state.options = {
				...initialState.options,
				variant: 'info',
				message: action.payload,
				autoHideDuration: 3000
			};
		}
	},
	selectors: {
		selectNotificationState: (notification) => notification.state,
		selectNotificationOptions: (notification) => notification.options
	}
});

/**
 * Lazy load
 */
rootReducer.inject(notificationSlice);
const injectedSlice = notificationSlice.injectInto(rootReducer);

export const { 
	hideMessage, 
	showMessage, 
	showSuccess, 
	showError, 
	showWarning, 
	showInfo 
} = notificationSlice.actions;

export const { 
	selectNotificationOptions, 
	selectNotificationState 
} = injectedSlice.selectors;

export default notificationSlice.reducer;